import { useSelector } from 'react-redux'
import { useJackpotHistoryResults } from '@hooks/queries/useJackpot'
import { JACKPOT_TABLE_HEADERS, JACKPOT_MESSAGES } from '@constants/jackpotConstants'
import JackpotTable from './JackpotTable'

const JackpotResultsTab = ({ jackpotId }) => {
  const currencyCode = useSelector((state) => state.wallet.displayCurrencyCode)
  const { data, isPending, isError } = useJackpotHistoryResults({ jackpotId })
  const rows = data?.rows ?? []

  return (
    <JackpotTable
      headers={JACKPOT_TABLE_HEADERS.RESULTS}
      rows={rows}
      isPending={isPending}
      isError={isError}
      emptyMessage={JACKPOT_MESSAGES.NO_RESULTS}
      currencyCode={currencyCode}
      medalRows
      renderRow={(row, index) => (
        <div key={index} className="standard-normal-jackpot-table-row">
          <div className="standard-normal-jackpot-table-cell">{row.position}</div>
          <div className="standard-normal-jackpot-table-cell">{row.userId}</div>
          <div className="standard-normal-jackpot-table-cell">{row.winningTicket}</div>
          <div className="standard-normal-jackpot-table-cell standard-normal-jackpot-table-cell-reward">
            {currencyCode} {row.reward}
          </div>
        </div>
      )}
    />
  )
}

export default JackpotResultsTab
